import { getCadastroAdicional } from '@/modules/cadastros-adicionais/cadastros-adicionais-utils';


const checkCamposErpSankhya = camposIntegracao => camposIntegracao.natureza;

const checkCamposErpTotvs = camposIntegracao => camposIntegracao.condicaoPagamento;

const checkCamposErpSenior = camposIntegracao => camposIntegracao.condicaoPagamento;

const checkCamposErpSeniorTeixeira = camposIntegracao => camposIntegracao.condicaoPagamento;

const checkCamposErpLm = camposIntegracao => camposIntegracao.tipoCobranca;

const checkCamposErpUseall = camposIntegracao => camposIntegracao.condicaoPagamento;

export const checkCadastrosAdicionaisErp = (tipoErp, camposIntegracao) => {
  if (tipoErp === 'TOTVS') {
    return checkCamposErpTotvs(camposIntegracao);
  }
  if (tipoErp === 'SANKHYA') {
    return checkCamposErpSankhya(camposIntegracao);
  }
  if (tipoErp === 'SENIOR') {
    return checkCamposErpSenior(camposIntegracao);
  }
  if (tipoErp === 'SENIOR_TEIXEIRA') {
    return checkCamposErpSeniorTeixeira(camposIntegracao);
  }
  if (tipoErp === 'LM') {
    return checkCamposErpLm(camposIntegracao);
  }
  if (tipoErp === 'USEALL') {
    return checkCamposErpUseall(camposIntegracao);
  }
  return false;
};

const validateCamposErpTotvs = (camposIntegracao) => {
  if (!camposIntegracao.condicaoPagamento) {
    return [false, 'Condição de pagamento é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpSenior = (camposIntegracao) => {
  if (!camposIntegracao.condicaoPagamento) {
    return [false, 'Condição de pagamento é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpSeniorTeixeira = (camposIntegracao) => {
  if (!camposIntegracao.condicaoPagamento) {
    return [false, 'Condição de pagamento é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpLm = (camposIntegracao) => {
  if (!camposIntegracao.tipoCobranca) {
    return [false, 'O tipo de cobrança é obrigatório'];
  }
  return [true, null];
};

const validateCamposErpUseall = (camposIntegracao) => {
  if (!camposIntegracao.condicaoPagamento) {
    return [false, 'Condição de pagamento é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpSankhya = (camposIntegracao) => {
  if (!camposIntegracao.natureza) {
    return [false, 'Natureza é obrigatório'];
  }
  return [true, null];
};

export const validateCamposErp = (tipoErp, camposIntegracao) => {
  if (tipoErp === 'TOTVS') {
    return validateCamposErpTotvs(camposIntegracao);
  }
  if (tipoErp === 'SANKHYA') {
    return validateCamposErpSankhya(camposIntegracao);
  }
  if (tipoErp === 'SENIOR') {
    return validateCamposErpSenior(camposIntegracao);
  }
  if (tipoErp === 'SENIOR_TEIXEIRA') {
    return validateCamposErpSeniorTeixeira(camposIntegracao);
  }
  if (tipoErp === 'LM') {
    return validateCamposErpLm(camposIntegracao);
  }
  if (tipoErp === 'USEALL') {
    return validateCamposErpUseall(camposIntegracao);
  }
  return [true, null];
};

export const computeFrom = (tipoErp, cadastrosAdicionais) => {
  if (tipoErp === 'TOTVS') {
    return {
      natureza: getCadastroAdicional(cadastrosAdicionais, 'NATUREZA') || null,
      condicaoPagamento: getCadastroAdicional(cadastrosAdicionais, 'CONDICAO_PAGAMENTO') || null,
    };
  }
  if (tipoErp === 'SANKHYA') {
    return {
      natureza: getCadastroAdicional(cadastrosAdicionais, 'NATUREZA') || null,
    };
  }
  if (tipoErp === 'SENIOR') {
    return {
      condicaoPagamento: getCadastroAdicional(cadastrosAdicionais, 'CONDICAO_PAGAMENTO') || null,
    };
  }
  if (tipoErp === 'SENIOR_TEIXEIRA') {
    return {
      condicaoPagamento: getCadastroAdicional(cadastrosAdicionais, 'CONDICAO_PAGAMENTO') || null,
    };
  }
  if (tipoErp === 'LM') {
    return {
      tipoCobranca: getCadastroAdicional(cadastrosAdicionais, 'TIPO_COBRANCA') || null,
    };
  }
  if (tipoErp === 'USEALL') {
    return {
      condicaoPagamento: getCadastroAdicional(cadastrosAdicionais, 'CONDICAO_PAGAMENTO') || null,
    };
  }
  return {};
};

export const initialStateCamposErp = (tipoErp) => {
  if (tipoErp === 'TOTVS') {
    return {
      natureza: null,
      condicaoPagamento: null,
    };
  }
  if (tipoErp === 'SANKHYA') {
    return {
      natureza: null,
    };
  }
  if (tipoErp === 'SENIOR') {
    return {
      condicaoPagamento: null,
    };
  }
  if (tipoErp === 'SENIOR_TEIXEIRA') {
    return {
      condicaoPagamento: null,
    };
  }
  if (tipoErp === 'LM') {
    return {
      tipoCobranca: null,
    };
  }
  if (tipoErp === 'USEALL') {
    return {
      condicaoPagamento: null,
    };
  }
  return {};
};
